import { VehicleRaw } from '../../vehicle/model/Vehicle';
import { VehicleDecoder } from '../../vehicle/utilities/vehicleDecoders';
import { Address, AddressRaw } from '../model/Address';
import { User, UserInfo, UserRaw } from '../model/User';

export const UserInfoDecoder = ({ id, email, phone, company, lastName, firstName, middleName }: UserRaw): UserInfo => {
  return {
    id,
    email,
    phone,
    company,
    lastName,
    firstName,
    middleName,
  };
};

export const UserAddressDecoder = ({
  countryCode,
  state,
  province,
  city,
  zipCode,
  postOfficeBox,
  street,
  streetType,
  houseNo,
  houseName,
  floorNo,
  doorNo,
  addressLine1,
  addressLine2,
  addressLine3,
  organisation,
  postcode,
  address,
  lines,
}: AddressRaw): Address => {
  return {
    countryCode,
    state,
    province,
    city,
    zipCode,
    postOfficeBox,
    street,
    streetType,
    houseNo,
    houseName,
    floorNo,
    doorNo,
    addressLine1,
    addressLine2,
    addressLine3,
    organisation,
    postcode,
    address,
    lines,
    parts: lines,
    line: lines?.join(', '),
  };
};

export const UserDecoder = (user: UserRaw): User => {
  return {
    id: user.id,
    token: user?.token ?? 'guest',
    address: UserAddressDecoder(user.address),
    info: UserInfoDecoder(user),
    vehicles: (user.vehicles || []).map((vehicle: VehicleRaw) => VehicleDecoder(vehicle)),
  };
};
